import { Injectable } from '@angular/core';
import { ListPagedArtifactsRequest, ListPagedArtifactsResponse, SituViewWebApiClient } from 'situview-webapi-client';
import { CacheConstants } from './cache-constants.service';
import { Cache, CacheClear } from './cache.service';
import { SituWarpApiClient, ListArtifactsRequest, ListArtifactsResponse } from 'situ-warpapi-client';

@Injectable({
  providedIn: 'root'
})
export class ArtifactService {

  constructor(
    private situViewClient: SituViewWebApiClient,
    private situWarpClient: SituWarpApiClient
  ) {}

  ListPagedArtifacts(request: ListPagedArtifactsRequest, refreshData: boolean = false): Promise<ListPagedArtifactsResponse> {
    return this.listPagedArtifacts(request, CacheConstants.ARTIFACTS_PREFIX, refreshData ? CacheClear.ReturnData : CacheClear.None);
  }

  ClearPagedArtifactsCache(): Promise<ListPagedArtifactsResponse> {
    return this.listPagedArtifacts(new ListPagedArtifactsRequest(), CacheConstants.ARTIFACTS_PREFIX, CacheClear.DoNotReturn);
  }

  @Cache({
    duration: 60000
  })
  ListArtifacts(request: ListArtifactsResponse): Promise<ListArtifactsResponse> {
    return this.situWarpClient.listArtifacts(request);
  }

  @Cache({
    duration: 300000
  })
  private listPagedArtifacts(request: ListPagedArtifactsRequest, cacheKeyPrefix: string, clearCache: CacheClear): Promise<ListPagedArtifactsResponse> {
    return this.situViewClient.listPagedArtifacts(request);
  }
}